var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 20,
    height: 20,
    transform: "translate(20) rotate(90)",
    fill: "#15345a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(-167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 24,
    height: 24,
    transform: "translate(167)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-download",
    transform: "translate(169 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M5.731,9.294a2.5,2.5,0,0,0,0,3.537l2.676,2.676a.833.833,0,0,0,1.176-1.178L7.144,11.89,20,11.9a.833.833,0,0,0,.833-.833h0A.833.833,0,0,0,20,10.229L7.16,10.222,9.583,7.8A.834.834,0,1,0,8.4,6.618Z",
    transform: "translate(-0.833 -1.062)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M6.667,19.167a.833.833,0,0,0-.833-.833H2.5a.833.833,0,0,1-.833-.833V2.5A.833.833,0,0,1,2.5,1.667H5.833A.833.833,0,1,0,5.833,0H2.5A2.5,2.5,0,0,0,0,2.5v15A2.5,2.5,0,0,0,2.5,20H5.833a.833.833,0,0,0,.833-.833Z",
    transform: "translate(0 0)",
    fill: "#15345a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMobile);
export default __webpack_public_path__ + "static/media/logoutMobile.e35ee59e3f2d2467d0f80c07a7ed3d5b.svg";
export { ForwardRef as ReactComponent };